import { FloatingToolbarSeparator } from '@atlaskit/editor-common/ui';
export default FloatingToolbarSeparator;